/*
  Revista Limonada — seletor de faixa etária.

  Os três produtos são renderizados inteiros pelo Liquid (preço, galeria,
  descrição e formulário de cada um). Este script só alterna qual conjunto está
  visível, então a troca é instantânea e os preços já vêm formatados pelo
  Shopify.

  Cada elemento que muda carrega data-rl-panel="<índice>". Trocar de faixa
  esconde todos os painéis cujo índice não é o escolhido, em qualquer grupo
  (galeria, título, preço, descrição, formulário).

  Nenhuma faixa vem marcada. Enquanto o cliente não escolhe, ficam visíveis só
  os painéis de prévia (data-rl-preview) e os do estado vazio (data-rl-empty),
  que incluem um botão substituto: clicar nele mostra o aviso pedindo a escolha
  em vez de adicionar qualquer produto ao carrinho.

  A galeria é um carrossel com scroll-snap nativo: quem move a imagem é o
  próprio navegador (swipe, arrasto, roda, teclado). Este script só lê a
  posição do scroll para atualizar o contador "1 / 6" e os bullets, e faz os
  bullets rolarem a trilha ao serem clicados.
*/
(function () {
  'use strict';

  // index null = nenhuma faixa escolhida ainda.
  function selectIndex(root, index) {
    root.querySelectorAll('[data-rl-panel]').forEach(function (panel) {
      panel.hidden = index === null ? !panel.hasAttribute('data-rl-preview') : panel.dataset.rlPanel !== index;
    });

    root.querySelectorAll('[data-rl-empty]').forEach(function (el) {
      el.hidden = index !== null;
    });

    if (index !== null) hideChooseMessage(root);

    /*
      Uma galeria escondida tem largura zero, então o scroll dela não sobrevive
      ao display:none. Ao reexibir, volta para a primeira imagem — que também é
      o estado esperado ao trocar de faixa etária.
    */
    var visible = root.querySelector('[data-rl-gallery]:not([hidden]) [data-rl-track]');
    if (visible) resetTrack(visible);
  }

  function hideChooseMessage(root) {
    var message = root.querySelector('[data-rl-choose-msg]');
    if (message) message.hidden = true;

    var options = root.querySelector('.rl-sel__options');
    if (options) options.classList.remove('rl-sel__options--alert');
  }

  function askToChoose(root) {
    var message = root.querySelector('[data-rl-choose-msg]');
    var options = root.querySelector('.rl-sel__options');
    if (message) message.hidden = false;

    if (options) {
      // Remove e recoloca a classe para a animação rodar de novo a cada clique.
      options.classList.remove('rl-sel__options--alert');
      void options.offsetWidth;
      options.classList.add('rl-sel__options--alert');

      var rect = options.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > window.innerHeight) {
        options.scrollIntoView({ behavior: supportsSmoothScroll ? 'smooth' : 'auto', block: 'center' });
      }
    }

    var first = root.querySelector('[data-rl-option]:not(:disabled)');
    if (first) first.focus({ preventScroll: true });
  }

  function scrollInstantly(track, left) {
    var behavior = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = left;
    track.style.scrollBehavior = behavior;
  }

  function resetTrack(track) {
    scrollInstantly(track, 0);
    syncGallery(track, 0);
  }

  /*
    scrollTo com objeto de opções é ignorado por navegadores antigos, que leem o
    argumento como coordenada e mandam a trilha para a posição 0. O suporte a
    scroll-behavior é o mesmo marco das duas coisas, então serve de detecção.
  */
  var supportsSmoothScroll = 'scrollBehavior' in document.documentElement.style;

  function scrollToIndex(track, index) {
    var left = track.clientWidth * index;

    if (supportsSmoothScroll) {
      track.scrollTo({ left: left, behavior: 'smooth' });
    } else {
      scrollInstantly(track, left);
    }
  }

  function currentIndex(track) {
    var width = track.clientWidth;
    if (!width) return 0;

    var index = Math.round(track.scrollLeft / width);
    var last = track.children.length - 1;
    return Math.max(0, Math.min(index, last));
  }

  function syncGallery(track, index) {
    var stage = track.parentElement;
    if (!stage) return;

    var current = stage.querySelector('[data-rl-current]');
    if (current) current.textContent = String(index + 1);

    stage.querySelectorAll('[data-rl-dot]').forEach(function (dot) {
      dot.setAttribute('aria-selected', String(Number(dot.dataset.rlDot) === index));
    });
  }

  function setupGallery(gallery) {
    var track = gallery.querySelector('[data-rl-track]');
    if (!track) return;

    /*
      O scroll dispara dezenas de vezes por arrasto; requestAnimationFrame
      reduz isso a uma atualização por quadro.
    */
    var queued = false;
    track.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          syncGallery(track, currentIndex(track));
        });
      },
      { passive: true }
    );

    gallery.querySelectorAll('[data-rl-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = Number(dot.dataset.rlDot);
        // Marca o bullet na hora: o feedback não espera a rolagem terminar.
        syncGallery(track, index);
        scrollToIndex(track, index);
      });
    });

    syncGallery(track, currentIndex(track));
  }

  function setup(root) {
    if (root.dataset.rlReady === 'true') return;
    root.dataset.rlReady = 'true';

    root.querySelectorAll('[data-rl-option]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) selectIndex(root, input.value);
      });
    });

    root.querySelectorAll('[data-rl-choose]').forEach(function (button) {
      button.addEventListener('click', function () {
        askToChoose(root);
      });
    });

    root.querySelectorAll('[data-rl-gallery]').forEach(setupGallery);

    // O navegador pode restaurar a faixa marcada ao voltar para a página.
    var checked = root.querySelector('[data-rl-option]:checked');
    selectIndex(root, checked ? checked.value : null);
  }

  function setupAll(scope) {
    (scope || document).querySelectorAll('[data-rl-selector]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupAll();
    });
  } else {
    setupAll();
  }

  // O customizer recria a seção a cada edição, sem recarregar a página.
  document.addEventListener('shopify:section:load', function (event) {
    setupAll(event.target);
  });
})();
